import Vue from 'vue'
import App from './App.vue'
import router from "./router/router";
import { store } from "./store";
import vuetify from "./plugins/vuetify";
import firebase from "firebase";
import "./styles/main.scss";
import wb from "./registerServiceWorker";
Vue.prototype.$workbox = wb;
Vue.config.productionTip = false
//Event bus used for communication between two child components 
export const eventBus = new Vue();

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  created() {
    // Initalize App with firebase to use SDKs
    // For Firebase JS SDK v7.20.0 and later, measurementId is optional
    firebase.initializeApp({
      apiKey: "AIzaSyDcLxeD6rsyfhBjj7AkZQRPtDCod1liwAQ",
      authDomain: "covid19-6bbe9.firebaseapp.com",
      databaseURL: "https://covid19-6bbe9.firebaseio.com",
      projectId: "covid19-6bbe9",
      storageBucket: "covid19-6bbe9.appspot.com",
      messagingSenderId: "213662330426",
      appId: "1:213662330426:web:6a9c97fa2cd46ea19acf03",
      measurementId: "G-46PCPR8GEE"
    });
  }
}).$mount('#app')
